// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1___0bf92c8aad15452ea65","cls2":"TagSelector-cls2___f291be89b259f822099 TagSelector-cls1___0bf92c8aad15452ea65"};